// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M17.5002 5V19H15.5002V5H17.5002ZM7.75015 5.33579L14.4144 12L7.75015 18.6642L6.33594 17.25L11.5859 12L6.33594 6.75L7.75015 5.33579Z"}}]};

const PageLastIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-last',
    ref,
    icon: element,
  },
));

PageLastIcon.displayName = 'PageLastIcon';

export default PageLastIcon;
